import { type ResultOf, type VariablesOf, graphql } from 'gql.tada';

const RefreshTokenMutation = graphql(`
  mutation RefreshMemberToken {
    refreshToken {
      token
      cdnToken
      status
      message
      valid
    }
  }
`);

export type MutationVariables = VariablesOf<typeof RefreshTokenMutation>;
export type MutationResult = ResultOf<typeof RefreshTokenMutation>;

export default RefreshTokenMutation;
